<main>
    <h1 class="sr-only">Delete Document Dialog</h1>
      <h2  mat-dialog-title>Confirm Document Deletion</h2>
    <mat-divider></mat-divider>
    <mat-dialog-content>
      <section>
        <div class="row"> 
          <div class="col-md-12">
            <span>Are you sure you want to delete this document?</span>
          </div>
        </div>
      </section>
    </mat-dialog-content>
    <mat-divider></mat-divider>
      <mat-dialog-actions align="end">
      <button  mat-button mat-dialog-close (click)="submit()" class="btn btn-primary modal-btn-blue">Yes</button>
      <button mat-button mat-dialog-close (click)="cancel()" class="btn modal-btn-white">No</button>
    </mat-dialog-actions>
  </main>